import { render } from "./PreviewTables.vue?vue&type=template&id=24272422"
import script from "./PreviewTables.vue?vue&type=script&lang=js"
export * from "./PreviewTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__